var React = require('react');

function ChartInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 22H8V26H5V22Z","fill":"#333F48","key":0}),React.createElement("path",{"d":"M11 20H14V26H11V20Z","fill":"#333F48","key":1}),React.createElement("path",{"d":"M18 17H21V26H18V17Z","fill":"#333F48","key":2}),React.createElement("path",{"d":"M24 15H27V26H24V15Z","fill":"#333F48","key":3}),React.createElement("path",{"d":"M5 15.3741L8 14V20H5V15.3741Z","fill":"#21A038","key":4}),React.createElement("path",{"d":"M11 13.1513L14 12V18H11V13.1513Z","fill":"#21A038","key":5}),React.createElement("path",{"d":"M18 10.1397L21 8.99996V15H18V10.1397Z","fill":"#21A038","key":6}),React.createElement("path",{"d":"M24 7.15311L27 6V13H24V7.15311Z","fill":"#21A038","key":7})]);
}

ChartInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ChartInline;

ChartInline.default = ChartInline;
